import t from 'tcomb';

export default function isEmpty(x) {
  t.assert(t.Obj.is(x));
  for (var k in x) {
    if (x.hasOwnProperty(k)) {
      return false;
    }
  }
  return true;
}





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/isEmpty.js
 **/